import { Controller } from "stimulus"
import { h, render, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { SwitchTransition, CSSTransition } from "@bmp/preact-transition-group";
import CartImg from '../images/dividend/Cart.gif';
import DiscoImg from '../images/dividend/Disco.gif';
import CheckImg from '../images/dividend/ic_anim_check.svg';

class AnimatedLoading extends Controller {

  showAnimation() {
    EventManager.emit('show-animation');
  }

  proceedAnimation() {
    EventManager.emit('next-animation-frame');
  }

  stopAnimation() {
    EventManager.emit('stop-animation-frame');
  }

  connect() {
    render(<AnimationContainer />, document.body)
  }
}

const AnimationContainer = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    EventManager.on('stop-animation-frame', () => {
      setShow(false);
    })
    EventManager.on('show-animation', () => {
      setShow(true);
    })
  }, [])

  return (
    show && (
      <Fragment>
        <AnimatedLoadingModal />
      </Fragment>
    )
  )
}

const AnimatedLoadingModal = () => {
  const [show, setShow] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentStepMessage, setCurrentStepMessage] = useState("Submitting account info...");
  const [currentStepImage, setCurrentStepImage] = useState(CartImg);
  const [currentTimeoutTimer, setCurrentTimeoutTimer] = useState(0);

  useEffect(() => {
    EventManager.on('next-animation-frame', () => {
      setCurrentStep(prevStep => prevStep + 1);
    })
  }, [])

  useEffect(() => {
    if (currentStep === 0) {
      setShow(true);
    }
    if (currentStep === 1) {
      setCurrentStepMessage("Payment Success!")
      setCurrentStepImage(CheckImg)
      setCurrentTimeoutTimer(setTimeout(() => {
        setCurrentStep(prevStep => prevStep + 1);
      }, 2000));
    } else if (currentStep === 2) {
      setCurrentStepMessage("Enjoy your premium experience")
      setCurrentStepImage(DiscoImg)
      setTimeout(() => {
        window.location.href = "/premium/"
      }, 2000);
    }
    return () => {
      clearTimeout(currentTimeoutTimer);
    }
  }, [currentStep])

  return (
    <CSSTransition
      in={show}
      classNames="n-fade-plain"
      timeout={700}
    >
      <div className="t-fixed t-top-0 t-left-0 t-w-screen t-h-screen t-z-100 t-flex" style={{ backgroundColor: 'rgba(97, 114, 135, 0.8)'}}>
        <SwitchTransition mode="out-in">
          <CSSTransition
            key={currentStep === 2}
            addEndListener={(node, done) => {
              node.addEventListener("transitionend", done, false);
            }}
            classNames="n-flip"
          >
            <div className={`t-relative t-w-60 t-h-60 t-rounded-lg t-m-auto t-flex`} style={{ transformStyle: 'preserve-3d', backgroundImage: `${currentStep === 2 ? 'linear-gradient(to top left, #bb8203, #ffe19f)' : 'linear-gradient(white, white)'}`}}>
              <div className="t-m-auto t-w-50 t-flex t-flex-col">
                <figure className={`t-flex t-rounded-full t-w-20 t-h-20 ${currentStep === 2 ? 't-bg-transparent' : 't-bg-indigo-100 t-overflow-hidden'} t-mb-5 t-mx-auto`}>
                  <SwitchTransition mode="out-in">
                    <CSSTransition
                      key={currentStepImage}
                      addEndListener={(node, done) => {
                        node.addEventListener("transitionend", done, false);
                      }}
                      classNames="n-translate-left"
                    >
                      <img src={currentStepImage} className={`t-w-full t-h-auto`} />
                    </CSSTransition>
                  </SwitchTransition>
                </figure>
                <SwitchTransition mode="out-in">
                  <CSSTransition
                    key={currentStepMessage}
                    addEndListener={(node, done) => {
                      node.addEventListener("transitionend", done, false);
                    }}
                    classNames="n-fade-plain"
                  >
                    <div className="t-flex t-min-h-12 t-justify-center">
                      <p className={`t-text-md t-m-0 t-font-semibold t-text-center ${currentStep === 2 ? 't-text-white' : ''}`}>
                        {
                          currentStepMessage
                        }
                      </p>
                    </div>
                  </CSSTransition>
                </SwitchTransition>
              </div>
            </div>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </CSSTransition>
  )
}

export default AnimatedLoading;
